import { Navigate, useLocation } from "react-router-dom";
import { destinoDeRutaAnterior } from "./rutasGeofence";

/**
 * Lleva una de las doce rutas anteriores a su sección y pestaña nuevas.
 *
 * `replace` para que el botón Atrás no regrese a la ruta vieja y vuelva a
 * redirigir, dejando a la persona atrapada.
 */
export default function RedirigirRutaAnterior({ ruta }) {
	const { search, hash } = useLocation();
	return <Navigate to={destinoDeRutaAnterior(ruta, search, hash)} replace />;
}
